import RestoreIcon from '@mui/icons-material/Restore';

export const RestoreTimeTrackingIcon = RestoreIcon;
